import {
  Box,
  Paper,
  styled,
  Typography,
  Modal,
  Button,
  TextField,
  Alert,
} from '@mui/material';
import Fade from '@mui/material/Fade';
import { store } from '../store';
import { useEffect, useState } from 'react';
import { FormControl } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { PagarComprobantePayload } from '../features/comprobantes/comprobantesAPI';
import { payComprobante } from '../features/comprobantes/comprobantesSlice';
import { Form } from '../features/payments/paymentsAPI';
import { useNavigate } from 'react-router-dom';

interface PaymentProps {
  openModal: boolean;
  setOpenModal: (v: boolean) => void;
  metodo: string;
  periodos: string[];
  total: string;
  tipoComprobante: string;
  nroComprobante: string;
  sendMail?: string;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  boxShadow: 24,
  padding: '2rem 2rem 2rem 2rem',
};

const ModalWrapper = styled(Paper)(({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  textAlign: 'center',
}));

export default function PaymentModal(props: PaymentProps) {
  const navigate = useNavigate();

  const {
    openModal,
    setOpenModal,
    metodo,
    periodos,
    total,
    tipoComprobante,
    nroComprobante,
    sendMail,
  } = props;

  const [selectedMethod, setSelectedMethod] = useState('');
  const [error, setError] = useState('');
  const [decidirFormData, setDecidirFormData] = useState<Form>();
  const [decidirUrl, setDecidirUrl] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('idle');
  ///E-pagos
  const [epagosFormData, setEpagosFormData] = useState<Form>();
  const [epagosUrl, setEpagosUrl] = useState('');


  const handlePayment = () => {
    if (metodo.substring(0, 7) === 'decidir' && selectedMethod === '') {
      setError('Debes seleccionar un método de pago. Cierre el formulario e intente nuevamente');
      return;
    } else if (metodo.substring(0, 6) === 'epagos' && selectedMethod === '') {
      setError('Debes seleccionar un método de pago. Cierre el formulario e intente nuevamente');
      return;
    }

    setPaymentStatus('loading');

    const payload: PagarComprobantePayload = {
      tipo: tipoComprobante,
      comprobante: nroComprobante,
      gateway_id: metodo.substring(0, 7) === 'decidir' ? 'decidir' : (metodo.substring(0, 6) === 'epagos' ? 'epagos' : metodo),
      email: sendMail,
      extra: metodo.substring(0, 7) === 'decidir' ? { method: selectedMethod } : (metodo.substring(0, 6) === 'epagos' ? { method: selectedMethod } : undefined),
    };

    store.dispatch(payComprobante(payload))
      .unwrap()
      .then(response => {
        if (metodo == 'mercadopago') {
          const redirectUrl = response.mercadopago_redirect;
          window.open(redirectUrl, '_blank');
        }

        if (response.form && response.url) {
          setDecidirFormData(response.form);
          setDecidirUrl(response.url);

          setEpagosFormData(response.form);
          setEpagosUrl(response.url);
        }

        setPaymentStatus('success');
      })
      .catch(() => {
        setPaymentStatus('idle');
      });
  };

  useEffect(() => {
    if (!decidirFormData) {
      return;
    }

    setTimeout(() => {
      const form = document.getElementById('decidirForm') as HTMLFormElement;
      form.submit();
    });
  }, [decidirFormData]);

  useEffect(() => {
    if (metodo.substring(0, 7) === 'decidir') {
      const tmp = metodo.split('-');
      setSelectedMethod(tmp[1]);
    }
  });


  //E-pagos
  useEffect(() => {
    if (!epagosFormData) {
      return;
    }

    setTimeout(() => {
      const form = document.getElementById('epagosForm') as HTMLFormElement;
      form.submit();
    });
  }, [epagosFormData]);

  useEffect(() => {
    if (metodo.substring(0, 6) === 'epagos') {
      const tmp = metodo.split('-');
      setSelectedMethod(tmp[1]);
    }
  });

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(!openModal)}
        closeAfterTransition
      >
        <Fade in={openModal}>
          <ModalWrapper sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2" mb={2}>
              {
                metodo === 'interbanking' && paymentStatus === 'success'
                  ? 'El comprobante fue enviado a la plataforma de Interbanking'
                  : metodo === 'interbanking'
                    ? 'Atención!'
                    : 'Confirmá tu método de pago'}
            </Typography>


            {
              metodo === 'interbanking' && paymentStatus !== 'success'
                ? <Typography>Esto no es HomeBanking. Interbanking es un servicio empresarial
                  que es necesario tener contratado.</Typography>
                : null
            }
            {
              paymentStatus === 'success' && metodo === 'interbanking'
                ? null
                : <Box my={2}>
                  {
                    metodo.substring(0, 6) === 'epagos'
                      ? <Typography>Por este método podrá abonar con Tarjeta de Crédito/ Debito,  HomeBanking, Transferencia, Billetera<br></br><br></br></Typography>
                      : ''
                  }
                  <Typography>
                    {
                      periodos.length > 1
                        ? `Estas pagando todas las cuotas entre ${periodos[0]} y la
                            cuota ${periodos.slice(-1)}.`
                        : `Estas seguro de pagar la cuota ${periodos[0]} por $${total}`}
                  </Typography>

                  <Typography>
                    <strong>
                      Método:{' '}
                      {
                        metodo.substring(0, 7) === 'decidir'
                          ? `Decidir - ${selectedMethod}`
                          : metodo.charAt(0).toUpperCase() + metodo.slice(1)
                      }
                    </strong>
                  </Typography>
                  <Typography variant="body2">
                    {' '}
                    <strong>Total: $ {total}</strong>
                  </Typography>
                </Box>
            }

            {
              error !== ''
                ? <Alert sx={{ width: '100%', marginBottom: '1rem' }} severity="error">
                  {error}
                </Alert>
                : null
            }
            {
              decidirFormData
                ? <FormControl fullWidth sx={{ display: 'none' }}>
                  <Box>
                    <form
                      id="decidirForm"
                      name="decidirForm"
                      method="post"
                      action={decidirUrl}
                    >
                      {Object.entries(decidirFormData).map(([key, value], i) => (
                        <TextField
                          key={i}
                          variant="outlined"
                          id={key}
                          name={key}
                          value={value}
                          label={key}
                          sx={{
                            margin: '.5rem',
                            width: '25%',
                          }}
                        />
                      ))}
                    </form>
                  </Box>
                </FormControl>
                : null
            }

            {
              epagosFormData
                ? <FormControl fullWidth sx={{ display: 'none' }}>
                  <Box>
                    <form
                      id="epagosForm"
                      name="epagosForm"
                      method="post"
                      action={epagosUrl}
                    >
                      {Object.entries(epagosFormData).map(([key, value], i) => (
                        <TextField
                          key={i}
                          variant="outlined"
                          id={key}
                          name={key}
                          value={value}
                          label={key}
                          sx={{
                            margin: '.5rem',
                            width: '25%',
                          }}
                        />
                      ))}
                    </form>
                  </Box>
                </FormControl>
                : null
            }

            {
              paymentStatus === 'success' && metodo === 'interbanking'
                ? <Typography sx={{ marginBottom: '1rem' }}>
                  Puede continuar su transacción desde el portal de Interbanking
                </Typography>
                : null
            }

            {
              paymentStatus === 'success' && metodo === 'interbanking'
                ? <Box sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  gap: 2,
                }}
                >
                  <Button
                    variant="contained"
                    sx={{ color: 'white', flexGrow: 1, fontSize: '.8rem' }}
                    onClick={() => {
                      navigate('/');
                    }}
                  >
                    Continuar en Autogestion
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{ fontSize: '.8rem', flexGrow: 1 }}
                    onClick={() =>
                      window.open('https://www.interbanking.com.ar/')
                    }
                  >
                    Ingresar a Interbanking
                  </Button>
                </Box>
                : paymentStatus === 'success' && metodo === 'mercadopago' ? (
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    gap: 2,
                  }}>
                    <Button
                      variant="contained"
                      sx={{ color: 'white', flexGrow: 1, fontSize: '.8rem' }}
                      onClick={() => {
                        navigate('/');
                      }}
                    >
                      Continuar en Autogestion
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{ fontSize: '.8rem', flexGrow: 1 }}
                      onClick={() =>
                        window.open('https://www.mercadopago.com.ar/')
                      }
                    >
                      Ingresar a MercadoPago
                    </Button>
                  </Box>
                ) : (
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                  }}>
                    <LoadingButton
                      loading={paymentStatus === 'idle' ? false : true}
                      variant="contained"
                      onClick={handlePayment}
                      sx={{ width: '40%' }}
                    >
                      Confirmar
                    </LoadingButton>
                    <Button
                      variant="outlined"
                      sx={{ width: '40%' }}
                      onClick={() => setOpenModal(!openModal)}
                    >
                      Cancelar
                    </Button>
                  </Box>
                )
            }
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
}
